import AsyncProcess from '../abstract/asyncProcess';
import RootProcessContext from './rootProcessContext';

/**
 * @inheritdoc
 */
abstract class RootProcess extends AsyncProcess<RootProcessContext> {}

export default RootProcess;
